import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import FolderWarrantiesListComponent from "features/document/edit/decision/warranties/components/FolderWarrantiesListComponent";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { loadFolderOffers } from "../actionCreators";
import { getFolderOffers } from "../selectors";
import { RightsContext } from "providers/RightsContext";

const openFolderOffer = (offerId, offerSiteId) => e => {
  e.stopPropagation();
  window.open(`/offers/${offerId}/${offerSiteId}`, "_blank");
};

export const FolderWarrantiesContainer = ({ documentId, siteId }) => {
  const dispatch = useDispatch();
  const { isImage } = useContext(RightsContext);
  const loaded = useSelector(state =>
    state.document.decision.folderOffers[`${documentId}-${siteId}`]
      ? state.document.decision.folderOffers[`${documentId}-${siteId}`].loaded
      : false
  );

  const folderOffers = useSelector(state => getFolderOffers(state, documentId, siteId), shallowEqual);

  useEffect(() => {
    if (!loaded) {
      dispatch(loadFolderOffers(documentId, siteId));
    }
  }, [loaded]); // eslint-disable-line react-hooks/exhaustive-deps

  return !isImage ? (
    <FolderWarrantiesListComponent folderOffers={folderOffers} openFolderOffer={openFolderOffer} />
  ) : (
    <></>
  );
};

FolderWarrantiesContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired
};

export default FolderWarrantiesContainer;
